import { makeObservable } from 'mobx'
import type { MobxDocument } from '../firestore-mobx'
import {
  ObservableModelWithDecorators,
  emptyCollection,
  emptyModel,
} from '../firestore-mobx/model'
import type { FirebaseRepository } from './FirebaseRepository'
import type { FirestoreSlideDeckRole } from '../firestore/SlideDeckRole'
import { empty } from '../firestore/SlideDeckRole'

export class SlideDeckRole extends ObservableModelWithDecorators<FirestoreSlideDeckRole> {
  static empty(repository: FirebaseRepository) {
    return emptyModel(repository, this, empty)
  }

  static emptyCollection(repository: FirebaseRepository) {
    return emptyCollection(repository, this, empty)
  }

  constructor(
    repository: FirebaseRepository,
    doc: MobxDocument<FirestoreSlideDeckRole>
  ) {
    super(repository, doc)

    makeObservable(this)
  }
}
